var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.181,
    height: 41.181,
    viewBox: "0 0 41.181 41.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2866",
    "data-name": "Group 2866",
    transform: "translate(0.255 0.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_559",
    "data-name": "Ellipse 559",
    cx: 20.59,
    cy: 20.59,
    r: 20.59,
    transform: "translate(-0.255 -0.292)",
    fill: "#00ac94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11482",
    "data-name": "Path 11482",
    d: "M-10849-14091.408c-.049,0-.1,0-.146,0a2.076,2.076,0,0,1-1.526-.844l-5.295-7.256a2.069,2.069,0,0,1,.452-2.891,2.07,2.07,0,0,1,2.891.453l3.85,5.273,13.738-14.131a2.07,2.07,0,0,1,2.928-.041,2.07,2.07,0,0,1,.038,2.926l-15.446,15.889A2.072,2.072,0,0,1-10849-14091.408Z",
    transform: "translate(10863.878 14121.436)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.01d95e1550aa0f930000225f455dedd9.svg";
export { ForwardRef as ReactComponent };